import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { format, formatDate } from "date-fns";
import { ExemptionVessel, Vessel, VesselAuction } from "interface/vessel";
import React from "react";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "utils/constant";

export const VesselRenderItem = (fixedLenght: boolean = true) => (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: Vessel = itemProps.dataItem;

	const fixedLenghtColumn = (value: string, length: number, title?: string) =>
		fixedLenght ? (
			<span style={{ display: "block", width: "180px", flexShrink: 0 }} title={title}>
				{value?.length > length ? `${value.slice(0, length - 3)}...` : value}
			</span>
		) : (
			<span style={{ display: "block", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={title}>
				{value}
			</span>
		);

	const item = (
		<div style={{ display: "flex", gap: "40px", width: "100%" }}>
			<div style={{ display: "flex", gap: "15px", flex: 1, minWidth: 0 }}>
				<span style={{ display: "block", width: "70px", flexShrink: 0 }}>
					{data.rn}
				</span>
				<span style={{ display: "block", width: "45px", flexShrink: 0 }}>
					{data?.cs}
				</span>

				{fixedLenghtColumn(data.nm, 22, data.nm)}
				{fixedLenghtColumn(data.owNm, 22, data.owNm)}

			</div>
			<div style={{ display: "flex", gap: "20px", flexShrink: 0 }} title={data.nm}>
				<span style={{ display: "block" }}>{format(new Date(data.toDate), 'dd.MM.yyyy')}</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export const AdminVesselRenderItem = (fixedLenght: boolean = true) => (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: Vessel = itemProps.dataItem;

	const fixedLenghtColumn = (value: string, length: number, title?: string) =>
		fixedLenght ? (
			<span style={{ display: "block", width: "180px", flexShrink: 0 }} title={title}>
				{value?.length > length ? `${value.slice(0, length - 3)}...` : value}
			</span>
		) : (
			<span style={{ display: "block", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={title}>
				{value}
			</span>
		);

	const item = (
		<div style={{ display: "flex", gap: "40px", width: "100%" }}>
			<div style={{ display: "flex", gap: "15px", flex: 1, minWidth: 0 }}>
				<span style={{ display: "block", width: "70px", flexShrink: 0 }}>
					{data.res}
				</span>
				<span style={{ display: "block", width: "70px", flexShrink: 0 }}>
					{data.rn}
				</span>
				<span style={{ display: "block", width: "45px", flexShrink: 0 }}>
					{data?.cs}
				</span>

				{fixedLenghtColumn(data.nm, 22, data.nm)}
				{fixedLenghtColumn(data.owNm, 22, data.owNm)}

			</div>
			<div style={{ display: "flex", gap: "20px", flexShrink: 0 }} title={data.nm}>
				<span style={{ display: "block" }}>{format(new Date(data.toDate), 'dd.MM.yyyy')}</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export const QuotaVesselRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: ExemptionVessel = itemProps.dataItem;

	const item = (
		<div style={{ display: "flex", gap: "40px" }}>
			<div style={{ display: "flex", gap: "15px" }}>
				<span style={{ display: "block", width: "80px" }}>
					{data.quotaVesselName}
				</span>
				<span style={{ display: "block", width: "80px" }}>
					{data.quotaVesselRegistrationId}
				</span>
				<span style={{ display: "block", width: "150px" }}>
					{data.quotaVesselRadioCallSignal}
				</span>
			</div>
			<div style={{ display: "flex", gap: "20px" }}>
				<span style={{ display: "block" }}>
					{format(new Date(data.validFrom), DATE_TIME_FORMAT)}
				</span>
				<span style={{ display: "block" }}>
					{format(new Date(data.validTo), DATE_TIME_FORMAT)}
				</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

export const AuctionObligationVesselsRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: VesselAuction = itemProps.dataItem;
	const item = (
		<div style={{ display: "flex", gap: "40px" }}>
			<div style={{ display: "flex", gap: "15px" }}>
				<span style={{ display: "block", width: "40px" }}>
					{data.fishermanLedgerAccount}
				</span>
				<span style={{ display: "block", width: "80px" }}>
					{data.vesselRegistrationId}
				</span>
				<span style={{ display: "block", width: "45px" }}>
					{data?.vesselRadioCallSignal}
				</span>
				<span style={{ display: "block", width: "150px" }} title={data.vesselName}>
					{data.vesselName?.length > 22 ? `${data.vesselName.slice(0, 19)}...` : data.vesselName}
				</span>
				<span style={{ display: "block", width: "150px" }} title={data.fishermanName}>
					{data.fishermanName?.length > 22 ? `${data.fishermanName.slice(0, 19)}...` : data.fishermanName}
				</span>
			</div>
			<div style={{ display: "flex", gap: "20px" }}>
				<span style={{ display: "block" }}>{format(new Date(data.validTo), 'dd.MM.yyyy')}</span>
			</div>
		</div>
	);

	return React.cloneElement(li, li.props, item);
};

